var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSalesmessage = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44226 13.9774C6.22728 14.3138 7.09189 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 9.64749 2.11293 11.1518 3.1232 12.2974L2.22847 13.4506C1.85991 13.9256 2.27837 14.6034 2.86816 14.4867L5.44226 13.9774Z",
    fill: "url(#paint0_radial_7748_146919)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.86572 10.1556L4.52257 7.37654C4.9584 6.92065 5.65858 6.84336 6.18335 7.19321L7.45765 8.04274C7.75929 8.24383 8.16714 8.1593 8.36401 7.85488L9.83651 5.57797C9.83651 5.57797 10.0693 5.27611 10.3897 5.45951C10.7102 5.64292 10.5689 5.99936 10.5689 5.99936L9.2212 9.71166C8.93356 10.504 7.9795 10.8173 7.27812 10.3497L6.03933 9.52386C5.75572 9.33479 5.37423 9.39691 5.16526 9.66618L3.12304 12.2978C2.57604 11.6775 2.14553 10.952 1.86572 10.1556Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7748_146919",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.85649 14.5) rotate(-64.5044) scale(11.4392 11.1468)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0780DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31A3FB"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSalesmessage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Salesmessage.50cbde47669f3ebd769c60953adeb4d5.svg";